
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import MasterService from './../../../../masterdata/services/masterdata.service';
import Loader from '../../../../shared/components/loader'
import AdminSettingsService from './../../../services/adminsettings.service';

export default {
  name: 'createDTHHubMapping',
  props:
    ['selectedDTHHubObj','actiondetail'],

  components: {
    //VueElementLoading,
    Paginate,
    Multiselect,
    Loader
  },
  data: function() {
    return {
      city: '',
      hubids:null,
      motherhubids:null,
      isLoading:false,
       hubaccessObjArray:[],
       motherhubArr:[],
      useremail:"",
      updateID:"",
      actionlabel:"",
      dthcapacity:""
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.getHubAccessList();
    if(this.selectedDTHHubObj){
      this.updateID = this.selectedDTHHubObj.id;
      this.hubids = {
        hubid:this.selectedDTHHubObj.hubid,
        hubname:this.selectedDTHHubObj.hubname
      },
      this.motherhubids = {
        hubid:this.selectedDTHHubObj.motherhubid,
        hubname:this.selectedDTHHubObj.motherhubname
      }
      if (!this.selectedDTHHubObj.vehiclecapacity) {
        this.getdthvehiclethreshold();
      } else {
        this.dthcapacity = this.selectedDTHHubObj.vehiclecapacity;
      }
    } else {
      this.hubids = null;
      this.motherhubids = null
    }
  },
  methods: {
    showCreateDTHmapping() {
      this.$emit("goBackToParent")
    },
    async getdthvehiclethreshold(){
      try{
        this.isLoading = true;
        let input = {}
      let response = await AdminSettingsService.GetDTHCapacityThreshold(input);
      if(response.data.code == 200){
        this.dthcapacity =   response.data.data.value[0]   
      }
      else{
        this.$alertify.error(response.data.message)
      }
        this.isLoading = false;

      }catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async getHubAccessList() {
      try {
        let InputPayload = {};
      this.isLoading = true;
      let response = await MasterService.GetHublist(InputPayload);
      if(response.data.code===200){
        this.hubaccess = response.data.data.data;
        for (var i = 0; i < this.hubaccess.length; i++) {
          this.hubaccessObjArray.push({
            hubid: this.hubaccess[i].HubID,
            hubname: this.hubaccess[i].HubName
          })
        }
        this.motherhubArr = this.hubaccessObjArray
        }
        else {
          this.$alertify.error(response.data.message);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async createDTHhubmapping(){
      try {
        var inputPayload = {};
        this.isLoading = true;
        
        if(this.motherhubids.hubid == this.hubids.hubid){
          this.$alert("Please select different Mother Hub and Child Hub","", "error");
        }else{
          inputPayload.motherhubid = this.motherhubids.hubid,
          inputPayload.motherhubname = this.motherhubids.hubname,
          inputPayload.hubname = this.hubids.hubname,
          inputPayload.hubid = this.hubids.hubid,
          inputPayload.lastmodifiedby = this.useremail;
          inputPayload.dthcapacitythreshold = Number(this.dthcapacity)
          let result = await AdminSettingsService.createDTHhubMapping(inputPayload);
          
          if (result.data.code == 200) {
            this.$alert(result.data.message, "", "success");
            this.$emit("goBackToParent");
          }else{
            this.$alert(result.data.message,"", "error");
          }
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.createDTHhubmapping(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    onSelectHub (event) {
      if (event.hubid) {
        this.getSelectedHubDetails(event.hubid);
      }
    },
    async getSelectedHubDetails (hubid) {
      this.isLoading = true;
      let inputPayload ={
        "offset": 0,
        "limit": 10,
      }
      inputPayload.hubid = hubid;
      let result = await AdminSettingsService.getDTHhubMappingList(inputPayload);
      if (result.data.code == 200) {
        let data = result.data.data.rows[0];
        this.motherhubids = {
          hubid: data.motherhubid,
          hubname: data.motherhubname
        }
        if (data.vehiclecapacity) {
          this.dthcapacity = data.vehiclecapacity
        } else {
          this.getdthvehiclethreshold();
        }
      } else {
        this.motherhubids = null;
        this.getdthvehiclethreshold();
      }
      this.isLoading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/dthhubmapping/Createdthhubmapping/Createdthhubmapping.component.js